<template>
  <!-- Partner nav drawer -->
  <v-navigation-drawer
    v-model="partnerDrawer"
    fixed
    temporary
    dark
    v-if="(isPartner || canViewPartnerAdmin) && !limitedUser"
    class="partner-admin-drawer"
  >
    <v-list class="pa-1">
      <v-list-item tag="div">
        <v-list-item-avatar>
          <v-img
            v-if="profileImage && profileImage.imageURL"
            :src="`${profileImage.imageURL}?w=200&h=200&fit=crop`"
            alt="User Profile Image"
            :lazy-src="lazyProfileImage"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="username" v-if="displayName">
            {{ displayName }} - Partner
          </v-list-item-title>
          <span class="text-caption">{{ currentPartnerID }}</span>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon @click.stop="changePartner">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-list class="py-0" dense>
      <v-divider></v-divider>

      <v-list-group
        v-for="item in partnerSubMenu"
        :key="item.title"
        :prepend-icon="item.icon"
        :value="item.active"
      >
        <v-list-item class="pl-0" slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="subItem in item.children"
          :key="subItem.title"
          @click="routeTo(subItem.to)"
        >
          <v-list-item-action>
            <v-icon class="subItem" small>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="subItem2">{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <template v-for="(item, i) in partnerMenu">
        <template v-if="!item.children">
          <v-list-item :key="i" @click="routeTo(item.to)">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'AppPartnerNavDrawer',
  props: {
    me: {
      type: Object,
      required: true,
    },
    isPartner: {
      type: Boolean,
      required: true,
    },
    drawer: {
      type: Boolean,
      required: true,
      default: false,
    },
    canViewPartnerAdmin: {
      type: Boolean,
      default: false,
    },
    limitedUser: {
      type: Boolean,
      default: false,
    },
    currentPartnerID: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      partner: {},
      partners: [],
      lazyProfileImage:
        'https://e6golf-qa-assets.imgix.net/shared/player-art/chipped.jpg?h=200&w=200&fit=crop',
    };
  },

  mounted() {},

  computed: {
    partnerMenu() {
      let menu = [];

      menu = [
        {
          title: 'Dashboard',
          icon: 'handshake',
          to: `/partner`,
        },
        {
          title: 'Product Keys',
          icon: 'checklist',
          to: `/partner/productkeys/${this.currentPartnerID}`,
        },
        {
          title: 'Create Product Keys',
          icon: 'key',
          to: `/partner/productkeys/${this.currentPartnerID}/create`,
          // children: [
          //   {
          //     title: 'Partner API Keys',
          //     icon: 'api',
          //     to: '/admin/partners',
          //   },
          // ],
        },
        {
          title: 'Product Key Report',
          icon: 'receipt_long',
          to: `/partner/productkeys/${this.currentPartnerID}/report`,
        },
      ];

      return menu;
    },

    partnerSubMenu() {
      return this.partnerMenu?.filter((item) => {
        return item.children;
      });
    },

    profileImage() {
      return this.me?.profileImage ? this.me?.profileImage : '';
    },

    displayName() {
      return this.me?.displayName ? this.me?.displayName : '';
    },

    partnerDrawer: {
      get() {
        return this.drawer;
      },
      set(val) {
        return val;
      },
    },
  },

  methods: {
    routeTo(data) {
      this.$emit('routeTo', data);
    },

    changePartner() {
      this.$emit('changePartner');
    },
  },
};
</script>

<style scoped>
.partner-admin-drawer {
  width: 300px !important;
}
.subItem2 {
  margin-left: 10px;
}
</style>
